export const state = () => ({
  agentNick: '',
  agentName: '',
});

export const getters = {
  getCSAgentNick(state) {
    return state.agentNick;
  },
  getCSAgentName(state) {
    return state.agentName;
  },
};

export const mutations = {
  setAgentNick(state, nick) {
    state.agentNick = nick;
  },
  setAgentName(state, name) {
    state.agentName = name;
  },
};

export const actions = {
  setAgentNick({ commit }, nick) {
    commit('setAgentNick', nick);
  },
  setAgentName({ commit }, name) {
    commit('setAgentName', name);
  },
};
